module.exports = __webpack_public_path__ + "img/procedure_01_sp.95d73936.png";